export const MIN_POST_BUDGET = 1000;
export const MAX_JOB_REFERENCES = 3;
export const REFERENCE_PROVIDERS = [
  ["YouTube",["youtube.com","youtu.be"]],["Vimeo",["vimeo.com"]],
  ["Instagram",["instagram.com","instagr.am"]],["TikTok",["tiktok.com"]],
  ["Drive",["drive.google.com","docs.google.com"]],["Dropbox",["dropbox.com"]],
  ["WeTransfer",["wetransfer.com","we.tl"]],["Behance",["behance.net"]],
];
export function parsePostBudget(raw) {
  const text = String(raw || "").trim().replace(/^[R$]\s*/i,"").replace(/[,\s]/g,"");
  return /^\d+(?:\.\d{1,2})?$/.test(text) ? Number(text) : 0;
}
export function jobReference(value,note="") {
  const text=String(value||"").trim();
  if(!text || /\s/.test(text)) return null;
  try {
    const url=new URL(/^[a-z][a-z0-9+.-]*:/i.test(text)?text:"https://"+text);
    if(!["http:","https:"].includes(url.protocol)||url.username||url.password) return null;
    const provider=REFERENCE_PROVIDERS.find(([,hosts])=>hosts.some(host=>url.hostname.toLowerCase()===host||url.hostname.toLowerCase().endsWith("."+host)));
    return provider?{url:url.href,platform:provider[0],...(note.trim()?{note:note.trim()}: {})}:null;
  } catch{return null;}
}
export function postDateError(form) {
  if(form.datesFlexible) return "";
  if(form.workEnd && !form.workStart) return "Choose a shoot start date before its end date.";
  if(form.workStart && form.workEnd && form.workEnd<form.workStart) return "The shoot end date cannot be before its start.";
  if(form.deadline && (form.workEnd || form.workStart) && form.deadline<(form.workEnd || form.workStart)) return "Delivery cannot be before the shoot finishes.";
  return "";
}
export function postFields(form,user,references,imageUrl) {
  const deadline=form.datesFlexible?"":form.deadline;
  return {
    title:form.title.trim(),role:form.role,
    companyName:form.companyName.trim() || user.name || user.displayName || "",
    payRate:"R"+parsePostBudget(form.budget),rateUnit:form.rateUnit,
    location:form.location.trim(),description:form.description.trim(),
    workStart:form.datesFlexible?"":form.workStart,workEnd:form.datesFlexible?"":form.workEnd,
    deadline,datesFlexible:form.datesFlexible,neededBy:deadline,timeline:deadline,
    references:references.slice(0,MAX_JOB_REFERENCES).map(item=>({url:item.url,platform:item.platform || "Link",...(item.note?.trim()?{note:item.note.trim()}: {})})),
    imageUrl,hostId:user.uid,hostName:user.name || user.displayName || "",
    hostProfilePic:user.profilePic || user.photoURL || "",
    type:"freelance",approvalStatus:"pending",
  };
}

